/*
 * @Author: changcheng
 * @LastEditTime: 2022-09-06 14:33:43
 */
import { Modal } from "antd";
import VideoPlayer from "@root/components/video/index";
import "./_style.scss";
interface videoPreview {
  setVisible: (type: boolean) => any;
}
export const VideoPreview = (props: videoPreview) => {
  const { setVisible } = props;
  return (
    <div>
      <Modal
        title="视频预览"
        visible={true}
        onCancel={() => {
          setVisible(false);
        }}
        footer={null}
      >
        <VideoPlayer />
      </Modal>
    </div>
  );
};
